import { ca } from '@cian/analytics';

export const trackHintClick = (hintElementId, adAnalyticsCategory) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'question_click',
    label: hintElementId,
  });
};

export const initializeHintClickTracking = (hintElementId, adAnalyticsCategory) => {
  const hintIcon = document.getElementById(hintElementId);

  if (!hintIcon) {
    return;
  }

  const onClickListener = () => {
    trackHintClick(hintElementId, adAnalyticsCategory);

    hintIcon.removeEventListener('click', onClickListener);
  };

  hintIcon.addEventListener('click', onClickListener);

  return () => {
    hintIcon.removeEventListener('click', onClickListener);
  };
};
